import { render, staticRenderFns } from "./trade-title.vue?vue&type=template&id=34098ab5"
import script from "./trade-title.vue?vue&type=script&lang=js"
export * from "./trade-title.vue?vue&type=script&lang=js"
import style0 from "./trade-title.vue?vue&type=style&index=0&id=34098ab5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports